/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {Domain} from './Domain';
import {FileType} from './FileType';
import {PropertyOptions} from './PropertyOptions';

/**
 * The Property model module.
 * @module model/Property
 * @version 1.0.0
 */
export class Property {
  /**
   * Constructs a new <code>Property</code>.
   * @alias module:model/Property
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>Property</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Property} obj Optional instance to populate.
   * @return {module:model/Property} The populated <code>Property</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Property();
      if (data.hasOwnProperty('_id'))
        obj._id = ApiClient.convertToType(data['_id'], 'String');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('shortcode'))
        obj.shortcode = ApiClient.convertToType(data['shortcode'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('photo'))
        obj.photo = FileType.constructFromObject(data['photo']);
      if (data.hasOwnProperty('domains'))
        obj.domains = Domain.constructFromObject(data['domains']);
      if (data.hasOwnProperty('options'))
        obj.options = PropertyOptions.constructFromObject(data['options']);
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'String');
      if (data.hasOwnProperty('updated'))
        obj.updated = ApiClient.convertToType(data['updated'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} _id
 */
Property.prototype._id = undefined;

/**
 * @member {String} title
 */
Property.prototype.title = undefined;

/**
 * @member {String} shortcode
 */
Property.prototype.shortcode = undefined;

/**
 * @member {String} description
 */
Property.prototype.description = undefined;

/**
 * @member {Boolean} enabled
 */
Property.prototype.enabled = undefined;

/**
 * @member {module:model/FileType} photo
 */
Property.prototype.photo = undefined;

/**
 * @member {module:model/Domain} domains
 */
Property.prototype.domains = undefined;

/**
 * @member {module:model/PropertyOptions} options
 */
Property.prototype.options = undefined;

/**
 * @member {String} created
 */
Property.prototype.created = undefined;

/**
 * @member {String} updated
 */
Property.prototype.updated = undefined;

